// GSAP
const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;
const SplitText = window.SplitText;
gsap.registerPlugin(ScrollTrigger, SplitText);


// Imports
import { mobileMenu } from './modules/mobileMenu.js';
import { headingUpdate } from './modules/headingUpdate.js';
import { lenisScroll } from './modules/lenis.js';
import { blogFilter } from './modules/blogFilter.js';
import { articleProgress } from './modules/articleProgress.js';
import { anchorScroll } from './modules/anchorScroll.js';
import { parallaxImage } from './modules/parallaxImage.js';
import { timeline } from './modules/timeline.js';
import { scanApp } from './modules/scanApp.js';
import { textReveal } from './modules/textReveal.js';
import { textFill } from './modules/textFill.js';
import { fadeInBlocks } from './modules/fadeInBlocks.js';
import { closeMobileMenu } from './modules/mobileMenu.js';

// Run imports
mobileMenu();
headingUpdate();
lenisScroll();
blogFilter();
articleProgress();
anchorScroll();
parallaxImage();
timeline();
scanApp();
textReveal();
textFill();
fadeInBlocks();
closeMobileMenu();